/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "regenerator-runtime/runtime";

// Only enable Flare in production, we don't want to waste your quota while you're developing:
if (process.env.NODE_ENV === 'production') {
    import('@flareapp/js').then(({ flare }) => {
        flare.light();
    });
}

require('./bootstrap');

window.Vue = require('vue');
window.Bus = new Vue();

// Bootstrap Vue
import { AlertPlugin, FormGroupPlugin, FormInputPlugin, FormCheckboxPlugin, FormRadioPlugin, FormTextareaPlugin, FormFilePlugin, FormDatepickerPlugin, ButtonPlugin, ModalPlugin, TablePlugin, TabsPlugin, TooltipPlugin, CarouselPlugin, NavbarPlugin, SpinnerPlugin, OverlayPlugin } from 'bootstrap-vue'
Vue.use(AlertPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormFilePlugin);
Vue.use(FormDatepickerPlugin);
Vue.use(ButtonPlugin);
Vue.use(ModalPlugin);
Vue.use(TablePlugin);
Vue.use(TabsPlugin);
Vue.use(TooltipPlugin);
Vue.use(CarouselPlugin);
Vue.use(NavbarPlugin);
Vue.use(SpinnerPlugin);
Vue.use(OverlayPlugin);

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faQuestionCircle, faCheck, faPlay, faClock, faReceipt } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faSpotify, faSoundcloud, faInstagram, faYoutube, faTwitter, faTiktok, faDiscord, faGoogle } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue';

library.add(faFacebook, faSpotify, faSoundcloud, faQuestionCircle, faCheck, faInstagram, faYoutube, faTwitter, faTiktok, faDiscord, faGoogle, faPlay, faClock, faReceipt)

Vue.component('font-awesome-icon', FontAwesomeIcon)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('auth-basic-component', require('./components/AuthBasicComponent.vue').default);
Vue.component('contact-form-component', require('./components/ContactFormComponent.vue').default);

Vue.component('artist-session-component', require('./components/ArtistSessionComponent.vue').default);
Vue.component('course-component', require('./components/CourseComponent.vue').default);
Vue.component('class-component', require('./components/ClassComponent.vue').default);
Vue.component('vod-course-component', require('./components/VODCourseComponent.vue').default);
Vue.component('vod-class-component', require('./components/VODClassComponent.vue').default);
Vue.component('quick-class-component', require('./components/QuickClassComponent.vue').default);
Vue.component('artist-component', require('./components/ArtistComponent.vue').default);
Vue.component('speaker-component', require('./components/SpeakerComponent.vue').default);
Vue.component('book-mentoring-btn-component', require('./components/BookMentoringBtnComponent.vue').default);
Vue.component('book-feedback-btn-component', require('./components/BookFeedbackBtnComponent.vue').default);
Vue.component('book-speaker-btn-component', require('./components/BookSpeakerBtnComponent.vue').default);
Vue.component('buy-teacher-feedback-product-btn-component', require('./components/BuyTeacherFeedbackProductButtonComponent.vue').default);
Vue.component('purchase-artist-session-component', require('./components/PurchaseArtistSessionComponent.vue').default);
Vue.component('purchase-course-component', require('./components/PurchaseCourseComponent.vue').default);
Vue.component('purchase-vod-course-component', require('./components/PurchaseVODCourseComponent.vue').default);
Vue.component('purchase-exam-component', require('./components/PurchaseExamComponent.vue').default);
Vue.component('preregister-artist-session-component', require('./components/PreregisterArtistSessionComponent.vue').default);
Vue.component('preregister-artist-session-handler-component', require('./components/PreregisterArtistSessionHandlerComponent.vue').default);
Vue.component('preregister-vod-course-component', require('./components/PreregisterVODCourseComponent.vue').default);
Vue.component('preregister-vod-course-handler-component', require('./components/PreregisterVODCourseHandlerComponent.vue').default);
Vue.component('preregister-exam-component', require('./components/PreregisterExamComponent.vue').default);
Vue.component('checkout-course-component', require('./components/CheckoutCourseComponent.vue').default);
//Vue.component('enrol-button-component', require('./components/EnrolButtonComponent.vue').default); // Defunct
Vue.component('enrol-artist-session-button-component', require('./components/EnrolArtistSessionButtonComponent.vue').default);
Vue.component('enrol-course-button-component', require('./components/EnrolCourseButtonComponent.vue').default);
Vue.component('enrol-vod-course-button-component', require('./components/EnrolVODCourseButtonComponent.vue').default);
Vue.component('enrol-exam-button-component', require('./components/EnrolExamButtonComponent.vue').default);
Vue.component('buy-vod-course-button-component', require('./components/BuyVODCourseButtonComponent.vue').default);
Vue.component('buy-exam-button-component', require('./components/BuyExamButtonComponent.vue').default);
//Vue.component('enrol-with-klarna-button-component', require('./components/EnrolWithKlarnaButtonComponent.vue').default); // Defunct
Vue.component('exam-enrolment-abstract-component', require('./components/ExamEnrolAbstractComponent.vue').default);
Vue.component('activity-card-component', require('./components/ActivityCardComponent.vue').default);
Vue.component('trailer-button-component', require('./components/TrailerButtonComponent.vue').default);

Vue.component('giftcard-component', require('./components/GiftCardComponent.vue').default);
Vue.component('giftcard-redemption-component', require('./components/GiftCardRedemptionComponent.vue').default);
Vue.component('subscribe-component', require('./components/SubscribeComponent.vue').default);
Vue.component('subscribe-flow-component', require('./components/SubscribeFlowComponent.vue').default);
Vue.component('stripe-coupon-component', require('./components/StripeCouponComponent.vue').default);
Vue.component('cancellation-reasons-component', require('./components/CancellationReasonsComponent.vue').default);
Vue.component('card-update-component', require('./components/CardUpdateComponent.vue').default);
Vue.component('past-payments-component', require('./components/PastPaymentsComponent.vue').default);
Vue.component('referral-redemption-component', require('./components/ReferralRedemptionComponent.vue').default);

Vue.component('partner-promo-code-component', require('./components/PartnerPromoCodeComponent.vue').default);

Vue.component('mux-video-component', require('./components/global/MuxVideoComponent.vue').default);

// Onboarding
Vue.component('onboarding-component', require('./components/profile/OnboardingComponent.vue').default);
Vue.component('welcome-component', require('./components/profile/WelcomeComponent.vue').default);
Vue.component('meta-profile-info-component', require('./components/profile/MetaProfileInfoComponent.vue').default);
Vue.component('genres-component', require('./components/profile/GenresComponent.vue').default);
Vue.component('profile-photo-onboarding-component', require('./components/profile/ProfilePhotoOnboardingComponent.vue').default);
Vue.component('username-selection-onboarding-component', require('./components/profile/UsernameSelectionOnboardingComponent.vue').default);
Vue.component('bio-onboarding-component', require('./components/profile/BioOnboardingComponent.vue').default);

Vue.component('onboarding-flow-component', require('./components/profile/OnboardingFlowComponent.vue').default);
Vue.component('onboarding-course-types-component', require('./components/profile/OnboardingCourseTypesComponent.vue').default);
Vue.component('onboarding-genres-component', require('./components/profile/OnboardingGenresComponent.vue').default);
Vue.component('onboarding-goals-component', require('./components/profile/OnboardingGoalsComponent.vue').default);
Vue.component('onboarding-found-options-component', require('./components/profile/OnboardingFoundOptionsComponent.vue').default);

// Profile
Vue.component('user-avatar-component', require('./components/profile/UserAvatarComponent.vue').default);
Vue.component('username-selection-component', require('./components/profile/UsernameSelectionComponent.vue').default);
Vue.component('bio-component', require('./components/profile/BioComponent.vue').default);
Vue.component('edit-profile-button-component', require('./components/profile/EditProfileButtonComponent.vue').default);
Vue.component('dob-update-component', require('./components/profile/DOBUpdateComponent.vue').default); // Part of ID verification

Vue.component('account-country-update-component', require('./components/profile/AccountUpdateCountryComponent.vue').default);

// ID verification
Vue.component('id-verification-component', require('./components/profile/IDVerifcationComponent.vue').default);

Vue.component('credit-transactions-component', require('./components/CreditTransactionsComponent.vue').default);
Vue.component('buy-credits-button-component', require('./components/BuyCreditsButtonComponent.vue').default);

// Exams
Vue.component('exam-card-component', require('./components/exams/ExamCardComponent.vue').default);
Vue.component('exam-component', require('./components/exams/ExamComponent.vue').default);
Vue.component('module-component', require('./components/exams/ModuleComponent.vue').default);
Vue.component('question-component', require('./components/exams/QuestionComponent.vue').default);
Vue.component('exam-results-component', require('./components/exams/ExamResultsComponent.vue').default);
Vue.component('exam-mux-video-upload-component', require('./components/exams/ExamsMuxVideoUploadComponent.vue').default);

// Feedback
Vue.component('feedback-user-component', require('./components/feedback/FeedbackUserComponent.vue').default);
Vue.component('feedback-track-upload-component', require('./components/feedback/TrackUploadComponent.vue').default);

// Generic/global
Vue.component('progress-circle-component', require('./components/global/ProgressCircleComponent.vue').default);

// Mini
Vue.component('artist-avatar-component', require('./components/ArtistAvatarComponent.vue').default);

// Playlists
Vue.component('playlist-manager-component', require('./components/PlaylistManagerComponent.vue').default);
Vue.component('playlist-button-component', require('./components/PlaylistButtonComponent.vue').default);
Vue.component('playlist-view-component', require('./components/PlaylistViewComponent.vue').default);
Vue.component('playlist-component', require('./components/PlaylistComponent.vue').default);

// SSO
Vue.component('sso-component', require('./components/SSOComponent.vue').default);

// Filters
Vue.component('query-toggle-component', require('./components/QueryToggleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});

// Handle the logout.  Here we fire a ajax request to X2O to logout via shapeImageThreshold:
window.handleLogout = function(e) {
    e.preventDefault();

    var oReq = new XMLHttpRequest();
    oReq.open("GET", "https://virtuoso.x2ocloud.com/XmanagerWeb/REST/v1/logout", true);
    oReq.withCredentials = true;
    oReq.send();

    setTimeout(function() {
        document.getElementById('logout-form').submit();
    }, 100);
}

// Lazy backgrounds
document.addEventListener("DOMContentLoaded", function() {
    var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background-data"));

    if ("IntersectionObserver" in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add("visible");
                    entry.target.style.backgroundImage = 'url("' + entry.target.dataset.bgImg + '")';
                    lazyBackgroundObserver.unobserve(entry.target);
                }
            });
        });

        lazyBackgrounds.forEach(function(lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    }
});

// Hotfix for vimeo videos
document.addEventListener("DOMContentLoaded", function(event) {
    const liteVimeo = document.querySelector('lite-vimeo')?.shadowRoot ?? null;
    if(liteVimeo === null) return;

    const elements = ['#frame', '#fallbackPlaceholder'];
    // Apply initial styles
    elements.forEach(element => {
        liteVimeo.querySelector(element).setAttribute('style', 'left:0;');
    });

    // Setup a MutationObserver to watch for changes in the shadow DOM
    const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(node => {
                    if (node.tagName === 'IFRAME') {
                        // Apply the style to the newly added iframe
                        node.style.left = '0';
                        // Optionally, disconnect the observer after applying the style if no further observation is needed
                        // observer.disconnect();
                    }
                });
            }
        }
    });

    // Start observing the shadow DOM for changes in the child elements
    observer.observe(liteVimeo, { childList: true, subtree: true });
});

require('./_navbar');
require('./_carousel');
require('lite-youtube-embed/src/lite-yt-embed.js');
import '@slightlyoff/lite-vimeo';
require('./_copy.js');
require('./_passwordToggle.js');
require('./_accordion.js');
require('./_expand.js');
